/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type ResponseCodeInterpreterCallCodeDeltaEvent = {
  type: "response.code_interpreter_call_code.delta";
  sequenceNumber: number;
  itemId: string;
  outputIndex: number;
  delta: string;
};

/** @internal */
export const ResponseCodeInterpreterCallCodeDeltaEvent$inboundSchema: z.ZodType<
  ResponseCodeInterpreterCallCodeDeltaEvent,
  z.ZodTypeDef,
  unknown
> = z.object({
  type: z.literal("response.code_interpreter_call_code.delta"),
  sequence_number: z.number().int(),
  item_id: z.string(),
  output_index: z.number().int(),
  delta: z.string(),
}).transform((v) => {
  return remap$(v, {
    "sequence_number": "sequenceNumber",
    "item_id": "itemId",
    "output_index": "outputIndex",
  });
});
/** @internal */
export type ResponseCodeInterpreterCallCodeDeltaEvent$Outbound = {
  type: "response.code_interpreter_call_code.delta";
  sequence_number: number;
  item_id: string;
  output_index: number;
  delta: string;
};

/** @internal */
export const ResponseCodeInterpreterCallCodeDeltaEvent$outboundSchema:
  z.ZodType<
    ResponseCodeInterpreterCallCodeDeltaEvent$Outbound,
    z.ZodTypeDef,
    ResponseCodeInterpreterCallCodeDeltaEvent
  > = z.object({
    type: z.literal("response.code_interpreter_call_code.delta"),
    sequenceNumber: z.number().int(),
    itemId: z.string(),
    outputIndex: z.number().int(),
    delta: z.string(),
  }).transform((v) => {
    return remap$(v, {
      sequenceNumber: "sequence_number",
      itemId: "item_id",
      outputIndex: "output_index",
    });
  });

export function responseCodeInterpreterCallCodeDeltaEventToJSON(
  responseCodeInterpreterCallCodeDeltaEvent:
    ResponseCodeInterpreterCallCodeDeltaEvent,
): string {
  return JSON.stringify(
    ResponseCodeInterpreterCallCodeDeltaEvent$outboundSchema.parse(
      responseCodeInterpreterCallCodeDeltaEvent,
    ),
  );
}
export function responseCodeInterpreterCallCodeDeltaEventFromJSON(
  jsonString: string,
): SafeParseResult<
  ResponseCodeInterpreterCallCodeDeltaEvent,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      ResponseCodeInterpreterCallCodeDeltaEvent$inboundSchema.parse(
        JSON.parse(x),
      ),
    `Failed to parse 'ResponseCodeInterpreterCallCodeDeltaEvent' from JSON`,
  );
}
